export default "/_next/static/images/f4b160ce32d52e37feb3d3d8374be4fe.jpg";